import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog as MatDialog, MatDialogConfig as MatDialogConfig, MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator as MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { CalendarComponent } from '../calendar/calendar.component';
import { UserDTO } from 'src/app/interfaces/user';
import { createCalendarIntegration, CalendarIntegrationDTO } from 'src/app/interfaces/calendarIntegration';
import { CalendarDTO, createCalendar } from 'src/app/interfaces/calendar';
import { CalendarIntegrationService } from 'src/app/services/calendar-integration.service';
import { catchError, EMPTY, firstValueFrom, Observable, of, switchMap, tap } from 'rxjs';
import { CalendarService } from 'src/app/services/calendar.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { environment } from 'src/environments/environment';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AccountTypeDTO } from 'src/app/interfaces/accountType';
import { AccountTypeService } from 'src/app/services/account-type.service';
import { NgIf } from '@angular/common';
import { createICal, ICalDTO } from 'src/app/interfaces/iCal';
import { CaldavDTO, createCaldav } from 'src/app/interfaces/calDav';
import { CaldavService } from 'src/app/services/caldav.service';
import { ICalService } from 'src/app/services/i-cal.service';
import { AppRegistrationDTO } from 'src/app/interfaces/appRegistration';
import { AppRegistrationService } from 'src/app/services/app-registration.service';
import { ColorPickerComponent } from "../color-picker/color-picker.component";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgForm } from '@angular/forms';
import { FunctionsService } from 'src/app/services/functions.service';
import { StandardResponseDTO } from 'src/app/interfaces/standardresponse';

@Component({
  selector: 'app-linked-account',
  imports: [MatPaginatorModule, MatIconModule, MatTableModule, MatTabsModule, FormsModule, MatLabel, MatFormFieldModule, MatButtonModule, MatInputModule,
    ReactiveFormsModule, MatToolbarModule, MatTooltipModule, NgIf, ColorPickerComponent, MatCheckboxModule],
  templateUrl: './linked-account.component.html',
  styleUrls: ['./linked-account.component.scss'],
})
export class CalendarIntegrationComponent implements OnInit {

  isLoggedIn: boolean;
  user: UserDTO;
  isOk: boolean;
  envClass = 'prod';

  calendarIntegration: CalendarIntegrationDTO;
  accountType: AccountTypeDTO;
  iCal: ICalDTO = { id: -1, userId: -1, url: "" };
  calDav: CaldavDTO = { id: -1, userId: -1, url: "", username: "", password: "" };
  calendar: CalendarDTO = { id: -1, userId: -1, calendarIntegrationId: -1, calendarIntegrationName: "", externalCalendarId: "", summary: "", showInDashboard: false, showInNotes: false, color: "white", uuid: "", taskUuid: "", url: "" };
  appRegistration: AppRegistrationDTO;
  calendars: CalendarDTO[];
  displayedColumns: string[] = ['Title', 'Show in dashboard', 'Show in notes', 'Calendar color'];
  dataSource = new MatTableDataSource<CalendarDTO>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  hide: boolean = true;
  standardResponse: StandardResponseDTO;
  error: boolean = false;
  errorMessage: string;
  emailControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);


  constructor(private tokenStorageService: TokenStorageService, private router: Router,
    public dialogRef: MatDialogRef<CalendarIntegrationComponent>, @Inject(MAT_DIALOG_DATA) data,
    private calendarIntegrationService: CalendarIntegrationService, private calendarService: CalendarService,
    public matDialog: MatDialog, private accountTypeService: AccountTypeService, private calDavService: CaldavService, private iCalService: ICalService,
    private functions: FunctionsService, private appRegistrationService: AppRegistrationService) {
    this.calendarIntegration = data;
  }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.isOk = true;
    }
    if (!this.isOk) {
      this.router.navigate(['home']);
    }
  }

  ngOnInit(): void {
    this.envClass = `env-${environment.name}`;
    this.isAuthorized();

    if (this.calendarIntegration?.email) {
      this.emailControl.setValue(this.calendarIntegration.email);
    }

    this.emailControl.valueChanges.subscribe((value) => {
      if (this.calendarIntegration) {
        this.calendarIntegration.email = value || '';
      }
    });

    this.getData().subscribe((data) => {
      // Ook even vullen als de data pas via getData binnenkomt:
      if (this.calendarIntegration?.email) {
        this.emailControl.setValue(this.calendarIntegration.email, { emitEvent: false });
      }
    });
  }

  getData(): Observable<any> {
    if (this.calendarIntegration) {
      return this.calendarService.getCalendars(this.calendarIntegration.id, false).pipe(

        tap({
          next: (data: any) => {
            this.calendars = data;
            this.dataSource.data = this.calendars;
          }
        }),

        switchMap(() => {
          return this.accountTypeService.getAccountType(this.calendarIntegration.accountTypeId);
        }),

        tap({
          next: (data: any) => {
            this.accountType = data;
          }
        }),

        switchMap(() => {
          if (this.accountType.code === "ICAL") {
            return this.iCalService.getICal(this.calendarIntegration.iCalId);
          } else if (this.accountType.code === "CALDAV") {
            return this.calDavService.getCaldav(this.calendarIntegration.calDavId);
          } else if (this.accountType.code === "APP_REGISTRATION") {
            return this.appRegistrationService.getAppRegistration(this.calendarIntegration.appRegistrationId);
          } else
            return of(null);
        }),

        tap({
          next: (data: any) => {
            if (this.accountType.code === "ICAL") {
              this.iCal = data;
              if (this.calendars && this.calendars.length > 0) {
                this.calendar = this.calendars[0];
              }

            } else if (this.accountType.code === "CALDAV") {
              this.calDav = data;
            } else if (this.accountType.code === "APP_REGISTRATION") {
              this.appRegistration = data;
            } else if (this.accountType.code === 'YOURNOTES') {
              this.calendar = this.calendars[0]
            }
          }
        }),

        catchError(error => {
          console.error("One of the API calls failed:", error);
          return EMPTY; // stop the stream
        })

      );
    } else return of(null);
  }

  onColorSelect(newColor: string): void {
    this.calendar.color = newColor;
  }

  refreshCalendars() {
    this.getData().subscribe();
  }

  async save() {
    if (this.emailControl.invalid) {
      this.emailControl.markAsTouched();
      return;
    }
    this.calendarIntegration.email = this.emailControl.value || '';

    const data = await firstValueFrom(this.calendarIntegrationService.saveCalendarIntegration(this.calendarIntegration.id, createCalendarIntegration(this.calendarIntegration.userId, this.calendarIntegration.accountTypeId, this.calendarIntegration.appRegistrationId, this.calendarIntegration.calDavId, this.calendarIntegration.iCalId, this.calendarIntegration.authorizationCode, this.calendarIntegration.accessToken, this.calendarIntegration.refreshToken, this.calendarIntegration.description, this.calendarIntegration.email)));
    this.calendarIntegration = data;
    if (this.accountType.code === 'ICAL') {
      this.iCal = await firstValueFrom(this.iCalService.saveICal(this.iCal.id, createICal(this.iCal.userId, this.iCal.url)));
      this.calendar = await firstValueFrom(this.calendarService.saveCalendar(this.calendar.id, createCalendar(this.calendar.userId, this.calendar.calendarIntegrationId, this.calendar.externalCalendarId, this.calendar.summary, this.calendar.showInDashboard, this.calendar.showInNotes, this.calendar.uuid, this.calendar.taskUuid, this.calendar.color, this.calendar.url)));
    }
    if (this.accountType.code === 'YOURNOTES') {
      this.calendar = await firstValueFrom(this.calendarService.saveCalendar(this.calendar.id, createCalendar(this.calendar.userId, this.calendar.calendarIntegrationId, this.calendar.externalCalendarId, this.calendar.summary, this.calendar.showInDashboard, this.calendar.showInNotes, this.calendar.uuid, this.calendar.taskUuid, this.calendar.color, this.calendar.url)));
    }
    if (this.accountType.code === 'CALDAV') {
      this.calDav = await firstValueFrom(this.calDavService.saveCaldav(this.calDav.id, createCaldav(this.calDav.userId, this.calDav.url, this.calDav.username, this.calDav.password)));
      this.calendars.forEach(async (cal) => {
        const data = await firstValueFrom(this.calendarService.saveCalendar(cal.id, createCalendar(cal.userId, cal.calendarIntegrationId, cal.externalCalendarId, cal.summary, cal.showInDashboard, cal.showInNotes, cal.uuid, cal.taskUuid, cal.color, cal.url)));
      });
    }
    this.dialogRef.close();
  }

  async delete() {
    this.error = false;
    const confirmed = await this.functions.confirmDialog("Delete linked account", "Are you sure you want to delete this linked account and all related calendars?");
    if (confirmed) {
      try {
        const data = await firstValueFrom(this.calendarIntegrationService.deleteCalendarIntegration(this.calendarIntegration));
        this.dialogRef.close(null);
      } catch (error) {
        this.errorMessage = "Can't remove this item as you have one of its calendars as active calendar.";
        this.error = true;
      }
    }
  }

  async reconsent() {
    const data = await firstValueFrom(this.calendarIntegrationService.getConsent(this.calendarIntegration, true));
    this.standardResponse = data;
    if (this.standardResponse.status == "GETCONSENT") {
      window.location.href = this.standardResponse.responseParameter;
    }

  }

  async revoke() {
    const confirmed = await this.functions.confirmDialog("Confirm revoking consent", "Are you sure you want to revoke consent from your account?");
    if (confirmed) {
      this.dialogRef.close(null);
      if (this.calendarIntegration.appRegistrationName.startsWith("Google")) {
        window.open("https://myaccount.google.com/permissions", "_blank");
      } else if (this.calendarIntegration.appRegistrationName.startsWith("Microsoft")) {
        window.open("https://myapplications.microsoft.com/", "_blank");
      }
      //}

    }
  }

  openCalendarModal(row) {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.data = row;
    dialogConfig.height = "461px";
    dialogConfig.width = "576px";
    const modalDialog = this.matDialog.open(CalendarComponent, dialogConfig);
    modalDialog.afterClosed().subscribe(data => {
      //this.removeFromList(data, this.calendars, true);
    });
  }

  removeFromList(changedCalendar: CalendarDTO, calendars: CalendarDTO[], replace: boolean) {
    var index = calendars.findIndex(x => x.id == changedCalendar.id);
    if (index > -1) {
      if (replace) {
        calendars.splice(index, 1, changedCalendar);
      } else {
        calendars.splice(index, 1);
      }
    }
  }

  /*async saveCaldavPassword(form: NgForm) {
    if (!this.newPassword || !this.newPassword2) {
      // Toon melding dat velden verplicht zijn
      return;
    }

    if (this.newPassword !== this.newPassword2) {
      // De HTML toont de error al, maar we blokkeren hier de save actie
      return;
    }

    const data = await firstValueFrom(this.calDavService.updateCaldavPassword(this.calDav.id, this.newPassword));
    if (data) {
      form.resetForm();
      this.newPassword = "";
      this.newPassword2 = "";
    }
  }*/

  getErrorMessage(): string {
    if (this.emailControl.hasError('required')) {
      return 'You must enter a value';
    }
    return this.emailControl.hasError('email') ? 'Not a valid email address' : '';
  }
}
